import { combineReducers } from 'redux';
import { createReducer, defaultListInitialState, defaultGetReducer } from 'utils';

import {
  GET_ALL_COUNTRIES
} from '../constants';

const countriesInitialState = defaultListInitialState();
const countries = createReducer(countriesInitialState, {
  [GET_ALL_COUNTRIES]: defaultGetReducer
});

export default combineReducers({ countries });



// WEBPACK FOOTER //
// ./src/reducers/companies.js